import React, {useState} from 'react';
import Form from "../../components/form";
import CircularProgress from "@mui/material/CircularProgress";

export default function PagamentoCartaoCredito({notificar, registrarPagamento, compraEmProcessamento}){
    const [cartao, setCartao] = useState({
        titularNome: "",
        numero: "",
        codigoVerificador: "",
        expiracao: ""
    });
    const [processandoPagamento, setProcessandoPagamento] = useState(false);
    const [msgRetornoPagamento, setMsgRetornoPagamento] = useState({});

    const preencherCartao = (campo, valor) => {
        switch(campo){
            case 'numero': 
                let numero = valor.replace(/\D/g, "");
                if (numero.length > 16) numero = numero.slice(0, 16);
                numero = numero.replace(/(\d{4})(?=\d)/g, "$1 ");

                setCartao({ ...cartao, numero });

                break;
            case 'codigoVerificador':
                if (/^\d{0,4}$/.test(valor)) setCartao({...cartao, codigoVerificador: valor});

                break;
            case 'expiracao':
                let expiracao = valor.replace(/\D/g, "");

                if (expiracao.length > 4) expiracao = expiracao.slice(0, 4);
                if (expiracao.length > 2) expiracao = expiracao.slice(0, 2) + "/" + expiracao.slice(2);
    
                setCartao({ ...cartao, expiracao});

                break;
            default: 
                setCartao({...cartao, [campo]: valor});

                break;
        }
    }

    const confirmarPagamento = () => {
        setProcessandoPagamento(true);
        setMsgRetornoPagamento({});

        let isOk = true;
        const nome = cartao.titularNome.split(' ')[0];
        const sobrenome = cartao.titularNome.replace(`${nome} `, '');
        const mesExpiracao = cartao.expiracao.split('/')[0];
        let anoExpiracao = cartao.expiracao.split('/')[1];

        if(!nome || !sobrenome){
            notificar('warning', 'Nome do titular inválido');
            isOk = false;
        }

        if(!cartao.numero || cartao.numero.length < 10){
            notificar('warning', 'Número inválido');
            isOk = false;
        }

        if(!cartao.codigoVerificador || cartao.codigoVerificador.length < 3){
            notificar('warning', 'Código verificador inválido');
            isOk = false;
        }

        if(!mesExpiracao || !anoExpiracao){
            notificar('warning', 'Mês/ano de expiração inválidos');
            isOk = false;
        } else {
            anoExpiracao = +anoExpiracao + 2000;

            if(+mesExpiracao < 1 || +mesExpiracao > 12){
                notificar('warning', 'Mês de expiração inválido');
                isOk = false;
            }

            if(anoExpiracao < new Date().getFullYear()){
                notificar('warning', 'Ano de expiração inválido');
                isOk = false;
            }
        }

        if(!isOk) return setProcessandoPagamento(false);

        try {
            const Iugu = window.Iugu;
            const modoTeste = cartao.titularNome.toUpperCase() === "TESTE TESTE";

            Iugu.setAccountID(process.env.REACT_APP_IUGU_CONTA_ID);
            Iugu.setTestMode(modoTeste);

            const cc = Iugu.CreditCard(
              cartao.numero.replace(/\s+/g, ""),
              mesExpiracao,
              anoExpiracao,
              nome,
              sobrenome,
              modoTeste ? 123 : cartao.codigoVerificador
            );

            Iugu.createPaymentToken(cc, (response) => {
                setProcessandoPagamento(false);

                if (response.errors) {
                    if (response.errors.number) setMsgRetornoPagamento({erro: true, msg: "Número do cartão inválido."});
                    if (response.errors.verification_value) setMsgRetornoPagamento({erro: true, msg: "Iugu: Código verificador inválido."});
                } else {
                    const requisicao = {
                        token: response.id,
                        descricao: `${response.extra_info.brand} ${response.extra_info.display_number}`,
                    };

                    registrarPagamento(requisicao.token);
                }
            });
        } catch (e) {
            setMsgRetornoPagamento({erro: true, msg: "Não foi possível conectar-se ao servidor para processar o pagamento. Por favor tente novamente mais tarde."});
            setProcessandoPagamento(false);
            console.log(e);
        }
    }

    const fCartao = {
        title: 'Cartão de crédito',
        form: {
            titularNome: {
                label: 'Nome do titular',
                type: 'text',
                value: cartao.titularNome,
                readOnly: processandoPagamento
            },
            numero: {
                label: 'Número',
                type: 'text',
                value: cartao.numero,
                space: 8,
                readOnly: processandoPagamento
            },
            codigoVerificador: {
                label: 'Código verificador',
                type: 'text',
                value: cartao.codigoVerificador,
                space: 2,
                readOnly: processandoPagamento
            },
            expiracao: {
                label: 'Expiração (MM/AA)',
                type: 'text',
                value: cartao.expiracao,
                space: 2,
                readOnly: processandoPagamento
            },
            legenda: {
                type: 'component',
                value: (
                    <div style={{textAlign: 'center', fontSize: 14}}>
                        <span>A Perto Educação não armaneza dados do seu cartão. Pagamento processado com segurança por <a href="http://iugu.com"target="_blank">Iugu</a>.</span>
                    </div>
                )
            },
            msgRetorno: {
                type: 'component',
                value: msgRetornoPagamento.msg ? (
                    <div style={{
                        textAlign: 'center', 
                        fontSize: 16, 
                        color: msgRetornoPagamento.erro ? 'red' : (msgRetornoPagamento.sucesso ? 'green' : 'black')
                    }}>
                        <span>{msgRetornoPagamento.msg}</span>
                    </div>
                ) : null
            },
            indicadorProcessamentoPgto: {
                type: 'component',
                value: processandoPagamento ? 
                    (<div style={{display: 'flex'}}>
                        <CircularProgress style={{marginRight: 15}}/> <p>Processando pagamento. Por favor, aguarde.</p>
                    </div> )
                : null
            }
        },
        submit: processandoPagamento || compraEmProcessamento ? undefined : {
            label: 'Confirmar pagamento',
            action: confirmarPagamento
        },
        autoSave: preencherCartao
    }

    return(
        <Form formData={fCartao} />
    )
}